"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteContentType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NoteContentType_Factory = /** @class */ (function () {
    function NoteContentType_Factory() {
    }
    NoteContentType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    NoteContentType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return NoteContentType_Factory;
}());
exports.NoteContentType_Factory = NoteContentType_Factory;
